import { demographicConstants } from '../../_constants';
import { demographicDataService } from '../../_services';
import { demographicDataAction } from '../UserProfile/demographicData.action';

export const addDemographicDataAction = {
    addDemographicDataHandler
};

function addDemographicDataHandler(data) {
    return dispatch => {
        dispatch(request());
        demographicDataService.addDemographicDataHandler(data)
            .then(
                demographicData => {
                    dispatch(demographicDataAction.getDemographicDataHandler())
                    dispatch(success(demographicData));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: demographicConstants.REQUEST_ADD_DEMOGRAPHIC_DATA} }
    function success(demographicData) { return { type: demographicConstants.RECIEVE_ADD_DEMOGRAPHIC_DATA, demographicData } }
    function failure(error) { return { type: demographicConstants.ERROR_ADD_DEMOGRAPHIC_DATA, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/demograpicMasters/addDemographicData.action.js